import React from 'react';
import { MdArrowDropDown, MdVisibility } from 'react-icons/md';
import { DropdownMenu } from 'ui';
import { LinkCodesTranslation } from '../constants';
import { useListCallbacks, useListSelectors } from '../hooks';
import { Visibility } from '../types-store';

import styles from './list-header-visibility.scss';

const shortLabel = {
  [Visibility.all]: (translation: LinkCodesTranslation) => translation.visible_all,
  [Visibility.selected]: (translation: LinkCodesTranslation) => translation.visible_selected,
  [Visibility.unselected]: (translation: LinkCodesTranslation) => translation.visible_show_unselected
} as const;

interface ListHeaderVisibilityProps {
  translation: LinkCodesTranslation;
}

export const ListHeaderVisibility: React.FC<ListHeaderVisibilityProps> = ({
  translation
}) => {

  const { visiblity } = useListSelectors();
  const { updateVisibility } = useListCallbacks();

  const onShowAll = () => {
    updateVisibility(Visibility.all);
  };

  const onShowSelected = () => {
    updateVisibility(Visibility.selected);
  };

  const onShowUnselected = () => {
    updateVisibility(Visibility.unselected);
  };

  const buttonNode = <div className={styles.hasMaxWidth}>
    <MdVisibility className={styles.visibilityIcon} />
    <span className={styles.visibilityLabel}>{shortLabel[visiblity](translation)}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  return <DropdownMenu dropdownNode={buttonNode} closeAfterClick>
    <li>
      <button id="show-all" className="dropdown-item" type="button" onClick={onShowAll}>
        {translation.visible_show_all}
      </button>
    </li>
    <li>
      <button id="show-selected" className="dropdown-item" type="button" onClick={onShowSelected}>
        {translation.visible_show_selected}
      </button>
    </li>
    <li>
      <button id="show-unselected" className="dropdown-item" type="button" onClick={onShowUnselected}>
        {translation.visible_show_unselected}
      </button>
    </li>
  </DropdownMenu>;
};
